import { GetImmatriculationCodeRejetRecyclAutoResponse } from "@/app/api/immat-code-rejet-recycl-auto/route";

import { getImmatriculationCodeRejetRecyclAutoRequestSchema } from "@/lib/schemas/immat-code-rejet-recycl-auto";

import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const IMMATRICULATION_CODE_REJET_RECYCL_AUTO_ENDPOINT =
  "/api/immat-code-rejet-recycl-auto";

export const invalidateImmatriculationCodeRejetRecyclAutoQuery =
  createInvalidateQuery(IMMATRICULATION_CODE_REJET_RECYCL_AUTO_ENDPOINT);

export const useImmatriculationCodeRejetRecyclAutoQuery =
  createQueryHook<GetImmatriculationCodeRejetRecyclAutoResponse>(
    IMMATRICULATION_CODE_REJET_RECYCL_AUTO_ENDPOINT,
    getImmatriculationCodeRejetRecyclAutoRequestSchema,
  );
